// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISpendLimitRemainingByAccountDto
 */
export interface ISpendLimitRemainingByAccountDto {
    /**
     * 
     * @type {number}
     * @memberof ISpendLimitRemainingByAccountDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISpendLimitRemainingByAccountDto
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISpendLimitRemainingByAccountDto
     */
    spend_limit_remaining?: number;
}

/**
 * Check if a given object implements the ISpendLimitRemainingByAccountDto interface.
 */
export function instanceOfISpendLimitRemainingByAccountDto(value: object): value is ISpendLimitRemainingByAccountDto {
    return true;
}

export function ISpendLimitRemainingByAccountDtoFromJSON(json: any): ISpendLimitRemainingByAccountDto {
    return ISpendLimitRemainingByAccountDtoFromJSONTyped(json, false);
}

export function ISpendLimitRemainingByAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISpendLimitRemainingByAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'spend_limit_remaining': json['spend_limit_remaining'] == null ? undefined : json['spend_limit_remaining'],
    };
}

export function ISpendLimitRemainingByAccountDtoToJSON(json: any): ISpendLimitRemainingByAccountDto {
    return ISpendLimitRemainingByAccountDtoToJSONTyped(json, false);
}

export function ISpendLimitRemainingByAccountDtoToJSONTyped(value?: ISpendLimitRemainingByAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'policy_id': value['policy_id'],
        'spend_limit_remaining': value['spend_limit_remaining'],
    };
}

